/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppRoutes {
  ACCOUNT_ACTIVATION = '/activate',
  ACCOUNT_REACTIVATION = '/resend-link/:token',
  ASSIGN_PRIVACY_ROUTE = '/privacy/:nrSeqTermo',
  ASSIGN_TERMS_ROUTE = '/terms-of-use/:nrSeqTermo/type/:termType',
  CHANGE_PASSWORD_ROUTE = '/change-password',
  COOKIES_POLICY_ROUTE = '/login/cookie-policy',
  CREATE_NEW_USER_PRIVACY_ROUTE = '/login/create-new-user/privacy-modal',
  CREATE_NEW_USER_ROUTE = '/login/create-new-user',
  CREATE_NEW_USER_TERMS_ROUTE = '/login/create-new-user/terms-of-use-modal',
  FORGET_PASSWORD_REQUEST_SUCCESS = '/forget-password/success',
  FORGET_PASSWORD_ROUTE = '/login/forget-password',
  HOME_ROUTE = '/home/dashboard',
  LOGIN_ROUTE = '/login',
  LOGIN_ROUTE1 = '/login',
  PASSWORD_RESET_SUCCESS_ROUTE = '/reset-password-success',
  PATIENTS_ROOT_ROUTE = '/patients',
  PREVIEW_ATTACHED_FILE_ROUTE = '/preview',
  PROFILE_VERSION = '/version',
  PUBLIC_SCHEDULING_ACTIONS = '/public/scheduling-actions/type/:type/:token',
  RESET_PASSWORD_ROUTE = '/reset-password',
  RESET_PASSWORD_TOKEN_FAILURE_ROUTE = '/reset-password-failure',
  ROUTE_AUTO_LOGOUT = '/logout-inactivity',
  ROUTE_LOGIN = '/login',
}
export { AppRoutes };
